import { createPostRequest, createGetRequest } from '_helpers';

export async function login(credentials) {
    return createPostRequest("login", credentials)
        .then(res => res.data)
        .then(({ success, data, errorMsg }) => {
            return { response: success, data, errorMsg };
        })
}

export async function logout() {
    return createGetRequest("logout")
        .then(res => res.data)
        .then(({ success, data, errorMsg }) => {
            return { response: success, data, errorMsg };
        })
}

export async function isLogged() {
    return createGetRequest("user_isLogged")
        .then(res => res.data)
        .then(({ success, data }) => {
            return { response: success, data };
        })
}